import { render, staticRenderFns } from "./BulkRegistrations.vue?vue&type=template&id=313ceb4d&scoped=true"
import script from "./BulkRegistrations.vue?vue&type=script&lang=js"
export * from "./BulkRegistrations.vue?vue&type=script&lang=js"
import style0 from "./BulkRegistrations.vue?vue&type=style&index=0&id=313ceb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ceb4d",
  null
  
)

export default component.exports